import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFoundationalCodeBooksQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFoundationalCodeBooksQuery = { __typename?: 'query_root', code_books: Array<{ __typename?: 'code_books', id: any, abbreviation: string, edition_year?: number | null, title: string }> };


export const GetFoundationalCodeBooksDocument = gql`
    query getFoundationalCodeBooks {
  code_books(
    where: {active: {_eq: true}, book_type: {_eq: "FOUNDATIONAL"}}
    order_by: [{abbreviation: asc}, {edition_year: desc}]
  ) {
    id
    abbreviation
    edition_year
    title
  }
}
    `;

/**
 * __useGetFoundationalCodeBooksQuery__
 *
 * To run a query within a React component, call `useGetFoundationalCodeBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoundationalCodeBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoundationalCodeBooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFoundationalCodeBooksQuery(baseOptions?: Apollo.QueryHookOptions<GetFoundationalCodeBooksQuery, GetFoundationalCodeBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoundationalCodeBooksQuery, GetFoundationalCodeBooksQueryVariables>(GetFoundationalCodeBooksDocument, options);
      }
export function useGetFoundationalCodeBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFoundationalCodeBooksQuery, GetFoundationalCodeBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoundationalCodeBooksQuery, GetFoundationalCodeBooksQueryVariables>(GetFoundationalCodeBooksDocument, options);
        }
export function useGetFoundationalCodeBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFoundationalCodeBooksQuery, GetFoundationalCodeBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFoundationalCodeBooksQuery, GetFoundationalCodeBooksQueryVariables>(GetFoundationalCodeBooksDocument, options);
        }
export type GetFoundationalCodeBooksQueryHookResult = ReturnType<typeof useGetFoundationalCodeBooksQuery>;
export type GetFoundationalCodeBooksLazyQueryHookResult = ReturnType<typeof useGetFoundationalCodeBooksLazyQuery>;
export type GetFoundationalCodeBooksSuspenseQueryHookResult = ReturnType<typeof useGetFoundationalCodeBooksSuspenseQuery>;
export type GetFoundationalCodeBooksQueryResult = Apollo.QueryResult<GetFoundationalCodeBooksQuery, GetFoundationalCodeBooksQueryVariables>;